{
  "id": 14,
  "location": "cafe",
  "difficulty": "normal",
  "moves": 14,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "collect", "kind": "latte", "count": 16 }
  ],
  "stars": [2240, 3230],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". ~. ~. ~. ~. ~. ~. .",
    ". ~. ~. ~. ~. ~. ~. .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.847, "movesLeft": 4.5, "closeLosses": 0.127, "target": 0.84 }
}
